<template>
	<transition-group
		name="slide"
		tag="div"
		class="w-notification"
		:class="{
			'w-notification--new-design': newDesign,
			'w-notification--new-design--small-screen': isExtraSmallScreen && newDesign,
		}"
		role="status"
		aria-live="polite"
	>
		<article
			v-for="(
				{ component: { text, template, props, state = null, persistent } }, id
			) in notificationStore.queue"
			:key="`n-${id}`"
			role="alert"
			aria-role="alert"
			@click="!persistent && notificationStore.close({ id })"
			:class="messageClasses(state)"
		>
			<span v-if="text">{{ text }}</span>
			<span v-else-if="template">
				<component
					:is="template"
					v-bind="props"
					@close-notification="notificationStore.close({ id })"
				/>
			</span>
		</article>
	</transition-group>
</template>

<script>
/* istanbul ignore file */
import { useNotificationsStore } from '@modules/notifications/m-notifications';
import { screenXS } from '@screens';
import mq from '@utils/matchMedia';

export default {
	name: 'w-notification',

	data() {
		return {
			newDesign: false,
		};
	},

	methods: {
		messageClasses(state) {
			return {
				'w-notification__message --closable': state === 'closable',
				'w-notification__message__newDesign --success': state === 'success',
				'w-notification__message__newDesign --error': state === 'error',
				'w-notification__message text-m-medium': state === undefined || !state,
			};
		},
	},

	computed: {
		isExtraSmallScreen: mq(screenXS),

		notificationStore() {
			return useNotificationsStore();
		},
	},

	watch: {
		'notificationStore.queue': {
			handler(queue) {
				// Asegurarse de que es un array
				if (Object.keys(queue).length === 0) {
					return;
				}

				let index = this.notificationStore.lastUID;
				const states = queue[index]?.component?.state;

				if (states) {
					this.newDesign = true;
				} else {
					this.stateClass = false;
				}
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.w-notification {
	display: flex;
	position: fixed;
	width: calc(100% - 20px);
	right: 10px;
	bottom: 80px;
	left: 10px;
	flex-direction: column;
	align-items: center;
	z-index: var(--z-index-notification);
	&--new-design {
		bottom: 60px;
		left: 60px;
		width: calc(100% - 100px);
	}
}

.w-notification__message {
	color: RGB(var(--color-text-white));
	width: 100%;
	max-width: 600px;
	padding: 20px;
	border-radius: var(--border-radius-s);
	margin-bottom: 10px;
	background-color: RGB(var(--color-primary-dark));
	flex-grow: 1;
}

.w-notification__message.--closable {
	padding-top: 0;
	padding-right: 0;
}

.w-notification__message__newDesign {
	color: RGB(var(--color-text-white));
	width: 100%;
	max-width: 800px;
	padding: 8px 16px 8px 16px;
	border-radius: var(--border-radius-s);
	margin-bottom: 10px;
	background-color: RGB(var(--color-primary-dark));
	flex-grow: 1;
	text-align: center;
	&.--success {
		background-color: RGB(var(--color-accent-success));
	}
	&.--error {
		background-color: RGB(var(--color-accent-error));
	}
}

.slide {
	will-change: transform;
}

.slide-enter-active {
	transition:
		opacity 300ms ease,
		transform 300ms ease;
}

.slide-leave-active {
	transition:
		opacity 200ms ease,
		transform 200ms ease;
}

.slide-enter,
.slide-leave-to {
	opacity: 0;
	transform: translateY(30px);
}

@media (min-width: 1024px) {
	.w-notification {
		&--new-design {
			left: 130px;
			right: 0px;
		}
	}
}

@media ($xs-screen) {
	.w-notification {
		&--new-design {
			left: 20px;
			bottom: 40px;
			width: calc(100% - 40px);
		}
	}
}
</style>
